export default function geolocation(config) {
    return {
        lat: config.lat || '',
        lng: config.lng || '',
        locationAddress: '',
        geoFeedback: '',
        geoReady: false,
        locale: config.locale || 'nl',
        mapsKey: config.mapsKey || '',
        messages: config.messages || {},

        init() {
            this.getLocation();
        },

        getLocation() {
            if (!navigator.geolocation) {
                this.geoFeedback = this.messages.impossible;
                return;
            }
            navigator.geolocation.getCurrentPosition(
                (position) => this.onSuccess(position),
                (error) => this.onError(error),
                { timeout: 10000, maximumAge: 60000 }
            );
        },

        onSuccess(position) {
            this.geoFeedback = '';
            if (this.lat === '') {
                this.lat = position.coords.latitude;
                this.lng = position.coords.longitude;
            }

            this.loadMapsApi().then(() => {
                this.reverseGeocode();
                this.geoReady = true;
            });
        },

        reverseGeocode() {
            const latlng = new google.maps.LatLng(parseFloat(this.lat), parseFloat(this.lng));
            const geocoder = new google.maps.Geocoder();

            geocoder.geocode({ location: latlng }, (results, status) => {
                if (status === 'OK' && results && results.length > 0) {
                    this.locationAddress = results[0].formatted_address;
                    const locationInput = document.getElementById('location');
                    if (locationInput) {
                        locationInput.value = this.locationAddress;
                    }
                } else {
                    console.error('Geocoding failed:', status);
                    this.locationAddress = '-';
                }
            });
        },

        onError(error) {
            if (error.code === error.PERMISSION_DENIED) {
                this.geoFeedback = this.messages.refused;
                return;
            }

            // Browser geolocation failed — fall back to Google Geolocation API (IP-based)
            this.getLocationFromGoogle();
        },

        getLocationFromGoogle() {
            fetch(`https://www.googleapis.com/geolocation/v1/geolocate?key=${this.mapsKey}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ considerIp: true }),
            })
                .then(response => response.json())
                .then(data => {
                    if (data.location) {
                        this.onSuccess({
                            coords: { latitude: data.location.lat, longitude: data.location.lng }
                        });
                    } else {
                        this.geoFeedback = this.messages.impossible;
                    }
                })
                .catch(() => {
                    this.geoFeedback = this.messages.impossible;
                });
        },

        loadMapsApi() {
            if (this._mapsLoaded) {
                return Promise.resolve();
            }

            if (this._mapsLoading) {
                return this._mapsLoading;
            }

            this._mapsLoading = new Promise((resolve) => {
                if (typeof google !== 'undefined' && google.maps) {
                    this._mapsLoaded = true;
                    resolve();
                    return;
                }

                const script = document.createElement('script');
                script.async = true;
                script.src = `https://maps.googleapis.com/maps/api/js?key=${this.mapsKey}&language=${this.locale}`;
                script.onload = () => {
                    this._mapsLoaded = true;
                    resolve();
                };
                document.head.appendChild(script);
            });

            return this._mapsLoading;
        },

        initMap() {
            const mapElement = document.getElementById('js-place-map');
            if (!mapElement || !this.lat || !this.lng) {
                return;
            }

            this.loadMapsApi().then(() => {
                this.renderMap(mapElement, parseFloat(this.lat), parseFloat(this.lng));
            });
        },

        mapStyles: [
            {
                stylers: [
                    { visibility: 'on' },
                    { saturation: -100 },
                ],
            },
            {
                featureType: 'administrative',
                elementType: 'geometry',
                stylers: [
                    { hue: '#002c65' },
                    { saturation: 75 },
                ],
            },
            {
                featureType: 'administrative',
                stylers: [
                    { hue: '#002c65' },
                    { lightness: 25 },
                    { saturation: 48 },
                ],
            },
        ],

        renderMap(mapElement, lat, lng) {
            const latlng = new google.maps.LatLng(lat, lng);
            const map = new google.maps.Map(mapElement, {
                zoom: 14,
                center: latlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: this.mapStyles,
                scrollwheel: false,
                disableDefaultUI: true,
            });

            new google.maps.Marker({
                position: latlng,
                map: map,
                icon: {
                    url: '/images/google-maps-marker.png',
                    scaledSize: new google.maps.Size(26, 32),
                },
            });
        },

        clearLocation() {
            this.lat = '';
            this.lng = '';
        }
    };
}
